module.exports = __webpack_public_path__ + "img/credit-card-2-front.3db0a487.svg";